import { render } from "./BSelect.vue?vue&type=template&id=2453ff8c"
import script from "./BSelect.vue?vue&type=script&lang=js"
export * from "./BSelect.vue?vue&type=script&lang=js"
script.render = render

export default script